import {
  AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild,
} from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { GoogleMap } from '@capacitor/google-maps';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-map-modal',
  templateUrl: './map-modal.component.html',
  styleUrls: ['./map-modal.component.scss'],
})
export class MapModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('map') mapElementRef: ElementRef;
  @Input() center = { lat: -34.379, lng: 150.644 };

  private nativeMap?: GoogleMap;
  private webGoogle?: any; // window.google.maps
  private webMap?: any;
  private clickListener?: any;

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private renderer: Renderer2
  ) { }

  ngOnInit() { }

  async ngAfterViewInit() {
    try {
      await this.initWebMap();
    } catch (e) {
      this.alertCtrl.create({
        header: 'Could Not Load Map',
        message: 'Map is not available at the moment. Please try again later!',
        buttons: [{ text: 'Dismiss', handler: () => this.modalCtrl.dismiss() }],
      }).then(a => a.present());
    }
  }

  ngOnDestroy() {
    if (this.clickListener && this.webGoogle) {
      this.webGoogle.event.removeListener(this.clickListener);
    }
    this.nativeMap?.destroy();
  }

  onCancel() { this.modalCtrl.dismiss(); }

  private async initWebMap() {
    const maps = await this.ensureGoogleMapsLoaded();
    this.webGoogle = maps;
    const mapEl = this.mapElementRef.nativeElement;
    this.webMap = new maps.Map(mapEl, { center: this.center, zoom: 16 });

    this.webGoogle.event.addListenerOnce(this.webMap, 'idle', () => {
      this.renderer.addClass(mapEl, 'visible');
    });

    const marker = new maps.Marker({ position: this.center, map: this.webMap, title: 'Picked Location' });
    this.clickListener = this.webMap.addListener('click', (event: any) => {
      const selected = { lat: event.latLng.lat(), lng: event.latLng.lng() };
      this.modalCtrl.dismiss(selected);
    });
  }

  private ensureGoogleMapsLoaded(): Promise<any> {
    const w = window as any;

    if (w.google?.maps) {
      return Promise.resolve(w.google.maps);
    }

    if (w.__googleMapsLoading) {
      return w.__googleMapsLoading;
    }

    w.__googleMapsLoading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      // Load from your API instead of Google directly
      script.src = environment.apiUrl + '/api/maps/script';
      script.async = true;
      script.defer = true;

      script.onload = () => {
        delete w.__googleMapsLoading;
        resolve(w.google.maps);
      };

      script.onerror = (error) => {
        delete w.__googleMapsLoading;
        reject(new Error('Failed to load Google Maps API'));
      };

      document.body.appendChild(script);
    });

    return w.__googleMapsLoading;
  }
}
